import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/AdInitializer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/ConsentBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/MobileNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/MountGate.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/PresenceClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/UserBadge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
